<div class="app-splash-screen" [ngStyle]="{ left: windowWidth, opacity: opacityChange }">
    <div class="d-flex justify-content-center align-items-center" style="min-height: 100vh;">
        <img src="assets/images/logo-circle.png" alt="Wajeez" class="animation" height="250px" width="250px" style="border-radius: 50%">
    </div>
</div>